import * as React from "react";

import { List } from "semantic-ui-react";

import { EmployeeRecord } from "../../crud/employeeRecord";

interface Props {
    employeeDetails: EmployeeRecord;
}

const ImmunisationRecordEmployeeDetails: React.FunctionComponent<Props> = (props) => {
    return (
        <List>
            <List.Item>{props.employeeDetails.firstName} {props.employeeDetails.lastName}</List.Item>
            {[
                props.employeeDetails.addressLine1,
                props.employeeDetails.addressLine2,
                props.employeeDetails.addressLine3,
                props.employeeDetails.city,
                props.employeeDetails.county,
                props.employeeDetails.postCode
            ].filter(a => !!a).map((addressLine, index) => <List.Item key={index}>{addressLine}</List.Item>)}
            <List.Item className="date-of-birth"><strong>Date of Birth: </strong>{props.employeeDetails.dateOfBirth?.format("DD/MM/YYYY")}</List.Item>
        </List>
    );
};

export { ImmunisationRecordEmployeeDetails };
